import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Poppins',

    },
    palette: {
        background: {
            default: '#00405B',
            paper: '#F3F9FD',
        },
        text: {
            primary: '#10213D',
            secondary: '#D1B192',
            opposite: '#FFFFFF',
            white: '#FFFFFF',
            red: '#A20006'
        },
        primary: {
            main: '#00405b',
            dark: '#00405b',
        },
        success: {
            main: '#871B1F',
            hover: '#A20006',
            contrastText: '#FFFFFF',
        },
        highlight: {
            main: '#ddddddff',
        },
    },
});

export default theme;